import { render, staticRenderFns } from "./MijnNathanLogin.vue?vue&type=template&id=6947f714&scoped=true&"
import script from "./MijnNathanLogin.vue?vue&type=script&lang=ts&"
export * from "./MijnNathanLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6947f714",
  null
  
)

export default component.exports